import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {catchError, mapTo, shareReplay, tap} from 'rxjs/operators';
import {Base64} from 'js-base64';
import {UserDetails} from "../../login/models/user.model";

export interface Credentials {
  userHash: string;
  password: string;
}

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private authenticated = false;

  constructor(private http: HttpClient) {
  }

  login(credentials: Credentials) {
    const basicString = 'Basic ' + Base64.encode(credentials.userHash + ':' + credentials.password);
    const headers = new HttpHeaders({
      authorization: basicString
    });

    return this.http
      .get<UserDetails>('auto-liquidation/user/login', {headers: headers})
      .pipe(tap(response => {
        if (response['username']) {
          this.authenticated = true;
        }
        return response;
      }));
  }

  isLoggedIn(hash: string) {
    const encodedHash = encodeURIComponent(hash);
    return this.http.get('auto-liquidation/user/check', {params: {'login': encodedHash}})
      .pipe(
        mapTo(true),
        catchError(() => of(false)),
        shareReplay(1)
      );
  }

  private logoutUser() {
    this.authenticated = false;
  }

  logout() {
    return this.http.get<Observable<any>>('auto-liquidation/user/logout')
      .pipe(
        tap(() => this.logoutUser()),
        catchError(error => {
          console.error('Error during logout', error);
          this.logoutUser();
          return of(null)
        })
      );
  }
}
